
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './error4045o606.scss';






const Perror4045o606 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id68a737e48e5aed52dc7cb54a" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu link-activo "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>ERROR 404</>
      </div>
      
      <div id="isx8s" className="">
      
      <img
        className=""
        id="ifsrx"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62oal3.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ih8ki" className="">
      
        <a
          target=""
          className="boton-principal "
          id="im9rt"
          href={`/`}
        >
          
    <div id="ienfg" className="">
    <>Regresar a la página principal</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Perror4045o606);
  